import { useTranslation } from 'react-i18next';

import { useConference } from '@core/dashboard/components/DashboardContent/Dolby';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { useMytaverse } from '@providers/MytaverseProvider';
import { NavigationModeType } from '@constants/navigationMode';

import SettingsGeneralView from './SettingsGeneralView';
const SettingsGeneral = () => {
  const { selectLanguage, selectedLanguage } = useMytaverse();
  const { streamQuality, setStreamQuality, isConferenceInitialized } =
    useConference();
  const {
    updateRoomScale,
    gameSound,
    setGameSound,
    participantsSound,
    setParticipantsSound,
    externalKeyboardConnected,
    setExternalKeyboardConnected,
    currentEventParticipant,
    selectNavigationMode,
  } = useMytaverseEvent();
  const { t: translate } = useTranslation();

  const selectedNavigationMode =
    (currentEventParticipant?.navigationMode as NavigationModeType) ||
    NavigationModeType.StrafeMode;

  const devices = [
    {
      label: translate('settingsModal.high'),
      deviceId: 'fhd',
    },
    {
      label: translate('settingsModal.medium'),
      deviceId: 'hdplus',
    },
    {
      label: translate('settingsModal.low'),
      deviceId: 'hd',
    },
  ];

  const handleChange = (event: Event, newValue: number | number[]) => {
    setGameSound((newValue as number) / 100);
  };

  const handleLoudness = (event: Event, newValue: number | number[]) => {
    setParticipantsSound((newValue as number) / 100);
  };

  return (
    <SettingsGeneralView
      selectLanguage={selectLanguage}
      selectedLanguage={selectedLanguage}
      selectNavigationMode={selectNavigationMode}
      selectedNavigationMode={selectedNavigationMode}
      setStreamQuality={setStreamQuality}
      streamQuality={streamQuality || 'High'}
      translate={translate}
      participantsSound={participantsSound}
      gameSound={gameSound}
      handleChange={handleChange}
      handleLoudness={handleLoudness}
      updateRoomScale={updateRoomScale}
      devices={devices}
      isConferenceInitialized={isConferenceInitialized}
      externalKeyboardConnected={externalKeyboardConnected}
      setExternalKeyboardConnected={setExternalKeyboardConnected}
    />
  );
};

export default SettingsGeneral;
